import React from 'react'
import * as commonStyles from '../index.css'
import * as styles from './smallerHeaderContent.css'
import {
  TitleText,
  CaptionText,
  Button,
  EditIcon,
  Row,
  Col,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import ClosedBadge from './ClosedBadge'

interface SmallerHeaderContentProps {
  groupName: string
  groupDescription: string
  isClosed: boolean
  isEditEnabled: boolean
  handleClickOnEdit: () => void
}

export const SmallerHeaderContent = ({
  groupName,
  groupDescription,
  handleClickOnEdit,
  isEditEnabled,
  isClosed,
}: SmallerHeaderContentProps) => {
  return (
    <Row data-testid="smallerHeader" noGutters>
      <Col xs={12}>
        <div className={styles.titleContainer}>
          <TitleText as="h3" className={styles.title}>
            {groupName}
          </TitleText>
          {isClosed && <ClosedBadge />}
          {isEditEnabled && (
            <Button
              data-testid="smallDetailEditButton"
              variant="tertiary"
              iconComponent={EditIcon}
              onClick={handleClickOnEdit}
              className={styles.editButton}
            >
              <Message id="detail.edit" />
            </Button>
          )}
        </div>
        <CaptionText as="p" className={commonStyles.description}>
          {groupDescription}
        </CaptionText>
      </Col>
    </Row>
  )
}
